import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import styles from './styles.css';

const DropdownMenuIcon = ({
  onClick,
  dataTestId,
  iconId,
  className,
  iconClassName,
  accessibility,
}) => (
  <span
    className={`${className && styles[className] ? `py-2.8 ${styles[className]}` : className}`}
    onClick={onClick}
    data-test-id={dataTestId}
  >
    <Icon id={iconId} accessibility={accessibility} className={iconClassName} />
  </span>
);

DropdownMenuIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  iconId: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  accessibility: PropTypes.object,
};

export default DropdownMenuIcon;
